import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { ActionsSection } from './ActionsSection';
import { MCISection } from './MCISection';
import { DefaultSection } from './DefaultSection';
import { ModelUpdatesSection } from './ModelUpdatesSection';

const SECTION_MAP = {
  ScenarioSelectionRedefinedActionsSection: ActionsSection,
  ScenarioSelectionRedefinedMonthlyCheckInSection: MCISection,
  ScenarioSelectionRedefinedModelUpdatesSection: ModelUpdatesSection,
};

const getSection = (sectionType) => {
  const section = SECTION_MAP[sectionType];
  if (!section) {
    return DefaultSection;
  }
  return section;
};

const Section = ({
  parentResource,
  sectionResource,
}) => {
  const SectionComponent = getSection(sectionResource.type());

  return (
    <SectionComponent
      parentResource={parentResource}
      sectionResource={sectionResource}
    />
  );
};

Section.defaultProps = {};

Section.propTypes = {
  parentResource: PropTypes.instanceOf(fr.Resource).isRequired,
  sectionResource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export { Section };
